var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgRupeeSymbol = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 71,
    viewBox: "0 0 60 71",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833496 1.75001C0.833496 1.75001 12.2612 1.75001 19.5835 1.75001M42.5001 76.75L9.16683 43.4167C9.16683 43.4167 15.4168 43.4167 19.5835 43.4167C23.7502 43.4167 44.5835 43.4167 44.5835 22.5833C44.5835 1.75001 23.7502 1.75001 19.5835 1.75001M59.1668 1.75001C59.1668 1.75001 31.7874 1.75001 19.5835 1.75001M0.833496 22.5833H59.1668",
    stroke: "#3C3ADA",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRupeeSymbol, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/rupee_symbol.b938f31b.svg";
export { ForwardRef as ReactComponent };